import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { GenerateShared } from './../shared/generate-shared';
import { SnackBarService } from './../../../data/repository/utils-repository/snack-bar.service';
import { BottomsheetShared } from './../shared/bottomsheet-shared';
import { Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-ios-new-bottomsheet',
  templateUrl: './ios-new-bottomsheet.component.html',
  styleUrls: ['./ios-new-bottomsheet.component.scss'],
})
export class IosNewBottomsheetComponent implements OnInit {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<IosNewBottomsheetComponent>,
    private bottomsheetShared: BottomsheetShared,
    private snackBarService: SnackBarService,
    private generateShared: GenerateShared,
    private planService: PlanService
  ) {}

  ngOnInit() {}

  buttonSelected(title: string) {
    if (title === 'گزارش ...') {
      this.bottomsheetShared.openReportBottomsheet();
    } else if (title === 'اشتراک گذاری') {
      let newVariable: any;
      newVariable = window.navigator;
      if (newVariable && newVariable.share) {
        newVariable
          .share({
            url: this.bottomsheetShared.shareLink,
          })
          .catch((e) => {
            this.snackBarService.showSnackBar('خطا در اشتراک گذاری');
          });
      } else {
        // this.snackBarService.showSnackBar('اشتراک گذاری در جست‌و‌جوگر شما پشتیبانی نمیشود');
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = this.bottomsheetShared.shareLink;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.snackBarService.showSnackBar('لینک پست کپی شد');
      }
    } else if (title === 'بله') {
      if (this.data.type === 'pending') {
        this.bottomsheetShared.pendingFoodsConfirm();
      } else {
        this.generateShared.isCanceling = true;
        this.planService.goToGenerate();
      }
    }
  }

  dismiss() {
    this.bottomSheetRef.dismiss();
  }
}
